export default __webpack_public_path__ + "static/media/clothsimulation3d_demo_image.a80af485.gif";